// Single place the API base URL is resolved. api.js (REST) and socket.js
// (socket.io) both import it so they can never point at different hosts.
const onLocalhost = window.location.hostname === 'localhost';

export const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (onLocalhost
    ? 'http://localhost:3001/api'
    : 'https://api.isittruenow.com/api');

if (!onLocalhost && /\/\/(localhost|127\.0\.0\.1)[:/]/.test(API_BASE_URL)) {
  console.error(`[config] API base resolves to ${API_BASE_URL} on ${window.location.hostname} — REACT_APP_API_URL is wrong for this build`);
}
